import * as type from '../ActionTypes';

const initialState = {
  contract: [],
  loading: false,
  error: '',
  contractedCoders: []
};

export default function contract(state = initialState, action: any) {
  switch (action.type) {
    case type.CONTRACT_INIT:
    case type.GET_CONTRACT_REQUEST:
    case type.GET_CONTRACT_BY_JOB_ID_REQUEST:
      return {
        ...state,
        loading: true
      };
    case type.GET_CONTRACT_REQUEST_FOR_CLIENT_DASH:
      return {
        ...state,
        loading: true,
        contract: []
      };
    case type.GET_CONTRACT_SUCCESS:
      return {
        ...state,
        loading: false,
        contract: action.payload
      };
    case type.GET_CONTRACT_BY_JOB_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        contractedCoders: action.payload
      };
    case type.GET_CONTRACT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.message || 'Something went wrong'
      };
    case type.RESET_CONTRACT_REQUEST:
      return {
        ...state,
        ...initialState
      };

    default:
      return state;
  }
}
